import React from 'react';
import { Image, ImageProps, ImageSourcePropType } from 'react-native';

interface Props extends ImageProps {
  source: ImageSourcePropType;
  width: number | string;
  height: number | string;
}

const CustomFastImage = ({ source, width, height, style, resizeMode = 'cover', ...props }: Props) => {
  return <Image resizeMode={resizeMode} source={source} style={[{ width, height }, style]} {...props} />;
};

export default CustomFastImage;
